<script lang="jsx">
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import TableHeadTr from './TableHeadTr.vue'
  import TableTh from './TableTh.vue'

  export default {
    components: {
      NewBsBox,
      TableHeadTr,
      TableTh,
    },
    props: [
      'bs',
      'propScopedSlots',
      'fixed',
      'defaultSize',
      'borderStyle',
      'defaultAlign',
      'columns',
      'shouldClacHeight',
      'theadTrHeightChange',
      'height',
    ],
    render() {
      return (
        <NewBsBox
          bs={this.bs}
          as="thead"
        >
          <TableHeadTr
            shouldClacHeight={this.shouldClacHeight}
            bs={{
              height: this.height ? `${this.height}px` : 'auto',
            }}
            {...{
              onTheadTrHeightChange: this.theadTrHeightChange,
            }}
          >
            {this.columns.map((column, colIndex) => (
              <TableTh
                key={colIndex}
                column={column}
                propScopedSlots={this.propScopedSlots}
                colIndex={colIndex}
                hidden={!this.fixed && Boolean(column.fixed)}
                borderStyle={this.borderStyle}
                size={column.size || this.defaultSize}
                align={column.align || this.defaultAlign}
              />
            ))}
          </TableHeadTr>
        </NewBsBox>
      )
    },
  }
</script>
